const CEF_SHARP_OBJECT_NOT_FOUND_RE =
  /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:4/;

function stringifyRejection(value: unknown) {
  if (typeof value === "string") {
    return value;
  }

  if (value instanceof Error) {
    return value.message;
  }

  if (value && typeof value === "object") {
    const maybeMessage = (value as { message?: unknown }).message;
    if (typeof maybeMessage === "string") {
      return maybeMessage;
    }
  }

  return "";
}

export function isKnownNonUserBrowserRejection(value: unknown) {
  return CEF_SHARP_OBJECT_NOT_FOUND_RE.test(stringifyRejection(value));
}
